
import Modal from "react-bootstrap/Modal";
import { Box,  IconButton, Typography, List, ListItem, ListItemText, Chip, Tooltip } from '@mui/material';
import React, { Component } from "react";
import {Button as Button_R} from "react-bootstrap";
import DeleteIcon from '@mui/icons-material/Delete';

export default class SelecteDocsHandle extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <div>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.props.showSelectedDocs}
                    onHide={() => this.props.onToggleSelectedDocs(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title> <h3>Manual Receipt Handling</h3> </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {<div>

                            <Box className="col-md-12" sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>

                                {!!this.props.manualReceiptFiles.length && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="h6">Selected Files:</Typography>
                                    <List dense>
                                    {Array.from(this.props.manualReceiptFiles).map((file, index) => (
                                        <ListItem key={index}>
                                        <ListItemText primary={file.name} />
                                        <Tooltip title= "click to clear selected files" >
                                            <IconButton 
                                                style={{
                                                    color: "#A2A5B5",
                                                    fontSize: "20px",
                                                }}
                                                onClick={() => this.props.removeSelectedDoc(index)}                            
                                            >
                                                <DeleteIcon fontSize="large"/>
                                            </IconButton>
                                        </Tooltip> 
                                        </ListItem>
                                    ))}
                                    </List>

                                </Box>
                                )}
                            </Box>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>                   
                        <Button_R
                            id="modal-close-button"
                            onClick={() =>
                                this.props.onToggleSelectedDocs(false)
                            }
                        >
                            Close
                        </Button_R>
                </Modal.Footer>
                </Modal>
            </div>
        )
    }
}



